import React from 'react';
import { isIOS, isAndroid } from 'react-device-detect';

const ReferralSafetyMessage = ({
  safetyMessage
}: {
  safetyMessage: string;
}) => {
  const [
    expandedSafetyMessages,
    setExpandedSafetyMessages
  ] = React.useState<boolean>(false);
  const [isTextOverflowing, setIsTextOverflowing] = React.useState<boolean>(
    false
  );
  const contentRef = React.useRef<HTMLDivElement>(null);

  // Check if text is overflowing (being clamped) by comparing scroll height vs client height
  React.useEffect(() => {
    const checkOverflow = () => {
      if (contentRef.current) {
        const isOverflowing =
          contentRef.current.scrollHeight > contentRef.current.clientHeight;
        setIsTextOverflowing(isOverflowing);
      }
    };

    // Check on mount and when safetyMessage changes
    checkOverflow();

    // Also check on window resize since text wrapping can change
    if (isIOS || isAndroid) {
      window.screen.orientation?.addEventListener('change', checkOverflow);
      return () =>
        window.screen.orientation?.removeEventListener('change', checkOverflow);
    } else {
      window.addEventListener('resize', checkOverflow);
      return () => window.removeEventListener('resize', checkOverflow);
    }
  }, [safetyMessage]);

  const toggleSafetyMessage = () => {
    setExpandedSafetyMessages((prev) => !prev);
  };

  return (
    <div className="mobile-view-safety-message-container">
      <div
        ref={contentRef}
        className={`mobile-view-safety-message-content ${
          expandedSafetyMessages ? 'mobile-view-safety-message-expanded' : ''
        }`}
      >
        <span className="mobile-view-safety-message-label">
          Safety message.{' '}
        </span>
        {safetyMessage}
        {expandedSafetyMessages && isTextOverflowing && (
          <button
            onClick={() => toggleSafetyMessage()}
            className="mobile-view-safety-message-button"
          >
            Show less
          </button>
        )}
      </div>
      {isTextOverflowing && !expandedSafetyMessages && (
        <div className="mobile-view-safety-message-more">
          <div>...</div>
          <button
            onClick={() => toggleSafetyMessage()}
            className="mobile-view-safety-message-button mobile-view-safety-message-show-more"
          >
            Show more
          </button>
        </div>
      )}
    </div>
  );
};

export default ReferralSafetyMessage;
